<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Setting Portal</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/skpddata">Setting Portal</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Setting Portal</h4>
                  <p class="card-title-desc mb-0">Pengaturan Utama Satudata, meliputi Pengaturan Tahun, dan lain sebagainya.</p>
                </div>
              </div>

              <hr />

              <div class="border-bottom">
                <form action="" method="post" @submit.prevent="action(['show_berita', 'show_artikel'])">
                  <h4>Pengaturan Beranda</h4>
                  <p class="text-muted">Atur apa yang akan tampil pada halaman utama.</p>

                  <div class="d-inline-block" style="max-width: 28em; width: 100%">
                    <div class="g-3 mb-3">
                      
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" id="show-box-kategori" v-model="settings.show_kategori">
                        <label class="form-check-label" for="show-box-kategori">Tampilkan Box Kategori</label>
                      </div>
                      
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" id="show-box-berita" v-model="settings.show_berita">
                        <label class="form-check-label" for="show-box-berita">Tampilkan Box Berita</label>
                      </div>

                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" id="show-box-artikel" v-model="settings.show_artikel">
                        <label class="form-check-label" for="show-box-artikel">Tampilkan Box Artikel</label>
                      </div>

                    </div>
                  </div>

                  <div class="mb-2">
                    <button type="submit" class="btn btn-primary">Simpan Perubahan</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>
</template>

<script>
import Layout from '@/layout/Index'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  layout: Layout,
  props: {
    _portalsetting: Object,
  },
  data() {
    return {
      settings: {
        show_kategori: false,
        show_berita: false,
        show_artikel: false
      }
    }
  },
  methods: {
    init() {
      const keys = Object.keys(this.settings);
      keys.map(key => {
        if(this._portalsetting && this._portalsetting[key])
          this.settings[key] = this._portalsetting[key];
      });
    },
    action(keys) {
      const data = {};
      for(let i in keys)
        data[keys[i]] = this.settings[keys[i]];
      
      if(Object.keys(data).length)
        this.$inertia.post('/admin/portal/setting', data);
    }
  },
  watch: {
    _portalsetting: {
      handle() {
        this.init();
      }, deep: true
    }
  },
  mounted() {
    this.init();
  }
}
</script>
